import { Globe } from "lucide-react";
import { LANGS, useLang } from "@/lib/i18n";

export const LangSwitch = ({ className = "", prefix = "" }) => {
  const { lang, setLang, t } = useLang();
  return (
    <div className={`lang-switch ${className}`} role="group" aria-label={t("lang.label")} data-testid={`${prefix}lang-switch`}>
      <Globe size={15} className="text-[var(--muted)]" aria-hidden />
      {LANGS.map(([k, short, name]) => (
        <button key={k} type="button" onClick={() => setLang(k)} title={name} aria-pressed={lang === k} className={`lang-opt ${lang === k ? "lang-on" : ""}`} data-testid={`${prefix}lang-option-${k}`}>
          {short}
        </button>
      ))}
    </div>
  );
};
